import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'select',
    'form',
    'formPartial',
    'button',
    'aspectClassSelect',
    'aspectTypeSelect',
  ];

  onSelect() {
    // Clear all the form fields, but remember the select value
    const rememberSelectValue = this.selectTarget.value;
    this.resetForm();
    this.selectTarget.value = rememberSelectValue;

    this.updateForm();
  }

  reset() {
    this.resetForm();
    this.updateForm();
  }

  resetForm() {
    this.formTarget.reset();

    this.formTarget.querySelectorAll('input,select').forEach((input) => {
      if (input.type === 'radio' || input.type === 'checkbox')
        input.checked = false;
      else input.value = '';
    });
  }

  updateForm() {
    this.formPartialTargets.forEach((formPartial) =>
      formPartial.classList.add('hidden'),
    );

    this.formPartialTargets.forEach((formPartial) => {
      if (formPartial.dataset.criterion === this.selectTarget.value) {
        formPartial.classList.remove('hidden');
      }
    });

    this.updateButtons();
  }

  updateButtons() {
    // Check if the form is completed
    let completed = false;

    this.formPartialTargets.forEach((formPartial) => {
      if (formPartial.dataset.criterion === this.selectTarget.value) {
        [...formPartial.querySelectorAll('input,select')].every((input) => {
          if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.checked) completed = true;
          } else {
            if (input.dataset.required == 'true' && input.value.length === 0) {
              completed = false;
              return false;
            }

            if (input.value.length > 0) completed = true;
          }

          return true;
        });
      }
    });

    this.buttonTargets.forEach((button) => (button.disabled = !completed));
  }

  // Filter the aspect types by the selected aspect class
  updateAspectTypes(event) {
    const selected = event.target.value;

    this.aspectTypeSelectTarget.value = '';
    this.aspectTypeSelectTarget.querySelectorAll('option').forEach((option) => {
      if (option.dataset.aspectClass)
        if (option.dataset.aspectClass == selected || !selected)
          option.removeAttribute('hidden');
        else option.setAttribute('hidden', true);
    });
  }

  // Preselect the aspect class when the aspect type is selected
  updateAspectClasses(event) {
    // Get aspectClass from selected option
    const option = event.target.querySelector(
      `option[value='${event.target.value}']`,
    );
    const aspectClass = option.dataset.aspectClass;

    if (aspectClass)
      // Set the aspectClass select to this aspectClass
      this.aspectClassSelectTarget.value = aspectClass;
    else this.aspectClassSelectTarget.value = '';

    // Hide all the options that don't have this aspectClass
    this.aspectTypeSelectTarget.querySelectorAll('option').forEach((option) => {
      if (option.dataset.aspectClass)
        if (option.dataset.aspectClass == aspectClass || !aspectClass)
          option.removeAttribute('hidden');
        else option.setAttribute('hidden', true);
    });
  }

  changeOtherRequired(event) {
    if (!event.target.dataset.other) return;

    const other = document.getElementById(event.target.dataset.other);

    if (event.target.value) other.dataset.required = 'false';
    else other.dataset.required = 'true';
  }
}
